import { Img, Heading, Button } from "../../components";
import React from "react";
import { useState, useEffect } from "react"
import axios from "axios"
import { useNavigate, useLocation } from "react-router-dom"
import { useAppContext } from "components/Context/AppContext";

const apiUrl = process.env.REACT_APP_API_URL;

export default function SecurityUploadSection() {
  const [token, setToken] = useState(null)
  const [file, setFile] = useState(null);
  const [isDragging, setIsDragging] = useState(false);
  const { setIsProcessRunning } = useAppContext();
  
  const navigate = useNavigate();

  useEffect(() => {
      // Check if token is already saved in localStorage
      const token = sessionStorage.getItem("token");
      if (token) {
        setToken(token)
      }
    }, []);

  const api_upload = async (file) => {
      const formData = new FormData();
      formData.append("file", file);
      console.log('api_upload:' + file.name)
      setIsProcessRunning(true)

      try {
          const response = await axios.post(`${apiUrl}/upload_security`, formData, {
              params: { 
                  'token': token
              },
              headers: {                   
                  "Content-Type": "multipart/form-data",
              },
          });
          console.log(response.data['message'])
          setIsProcessRunning(false)
          //alert("File uploaded successfully");
          
      } catch (error) {
          setIsProcessRunning(false)
          //alert("File upload failed");
          console.log('upload portfolio failed:', error)
      }
  }

  // Handle file drop
  const handleDrop = (e) => {
      e.preventDefault();
      setIsDragging(false);
      
      // Get the first file dropped
      const droppedFile = e.dataTransfer.files[0];
      setFile(droppedFile);
      
      // Optionally, you can upload the file here or pass it to a function
      if (droppedFile) {
          console.log("Dropped file:", droppedFile);
      }
  };
  
  // Handle drag events
  const handleDragOver = (e) => {
      e.preventDefault();
      setIsDragging(true);
  };
  const handleDragLeave = () => {
      setIsDragging(false);
  };
  // Add this function inside the FileDropZone component
  const handleFileSelect = (e) => {
      const selectedFile = e.target.files[0]
      setFile(selectedFile);
  };


  const handleSubmit = async (event) => {
      event.preventDefault();
      api_upload(file)
      setFile(null)
      //navigate('/dashboard')
  };

  const download_template_url = () => {
    return `${apiUrl}/sup_download/public/security_upload_template.xlsx` + "?token="+token;
  }

  return (
    <>
      {/* portfolio upload section */}
      <div className="flex flex-col items-center self-stretch">
        <div className="container-xs flex flex-col items-start gap-[42px] md:px-5">
          <div className="flex flex-col items-center self-stretch p-[30px] sm:p-5">
            <p className="mt-2 text-[20px] font-medium text-white-a700">
              <a href={download_template_url()} >Download <u style={{color: "red"}}>security_upload_template.xlsx</u></a>
            </p>
              {/* Area for file to drop */}
              <div 
                onDrop={handleDrop}
                onDragOver={handleDragOver}
                onDragLeave={handleDragLeave}
                style={{
                  backgroundColor: isDragging ? '#e6f7ff' : '#1f2023',
                  transition: 'background-color 0.3s',
                }}
                className="mt-6 flex flex-col items-center justify-center self-stretch border border-dashed border-blue_gray-400 p-10 sm:p-5">
                
                <Img src="images/img_iwwa_upload.svg" alt="Upload Image" className="h-[92px] w-[92px]" />
                <input
                    id="fileInput"
                    type="file"
                    style={{ display: 'none' }}
                    onChange={handleFileSelect}
                />
                {file ? (
                  <> 
                    <Heading size="textxl" as="h2" className="text-[16px] font-medium text-white-a700 md:text-[22px]">
                      File selected: {file.name}
                    </Heading>
                  </>
                ) : (
                  <>
                    <Heading size="textxl" as="h3" className="text-[24px] font-medium text-blue_gray-400 md:text-[22px]">
                      Drag & Drop to upload
                    </Heading>

                    <Heading onClick={() => document.getElementById("fileInput").click()}
                      size="texts" as="h4" className="mt-2 text-[20px] font-medium text-pink-a200 underline">
                      Or browse files
                    </Heading>
                  </>
                )}
                
              </div>

            <Button
              onClick={handleSubmit}
              color="indigo_A700"
              size="xl"
              shape="square"
              className="mb-[18px] mt-6 min-w-[348px] px-[34px] sm:px-5 text-3xl"
            >
              Upload
            </Button>
          </div>
        </div>
      </div>
    </>
  );
}
